<template>
  <div class="about-wr-details">
    <main class="about-wr-details-main">
      <img loading="lazy" class="main-bg" src="@/assets/img/aboutWR/1.png" alt="">
      <div class="container">
        <div class="side">
          <div class="title">关于沃瑞</div>
          <div v-for="(item, index) in aboutList" :key="index" class="about-item" :class="{ active: index == activePart }"
            @click="activePart = index">
            <el-divider></el-divider>
            <span class="part">{{ item.part }}</span>
          </div>
        </div>
        <div class="content">
          <el-card>
            <div v-if="activePart != 2">{{ aboutList[activePart].content }}</div>
            <template v-else>
              <div v-for="item in honorList" :key="item.index" class="honor-item">
                <img loading="lazy" class="honor-icon" src="@/assets/img/aboutWR/7.png" alt="">
                <div class="name">{{ item.name }}</div>
              </div>
            </template>

          </el-card>

          <el-card v-if="activePart == 3" class="card3">
            {{ aboutList[activePart].content2 }}
          </el-card>
        </div>


      </div>
    </main>
    <Footer class="footer" />
  </div>
</template>

<script>
import Footer from '@/components/footer/index'
export default {
  name: '',
  components: {
    Footer
  },
  props: [],
  data() {
    return {
      aboutList: [
        {
          part: '沃瑞介绍',
          content: ' 杭州沃瑞电力科技有限公司成立于2011年7月，是一家具有综合竞争力的高新技术企业，公司专业研发、生产、销售电网相关应用系统，现有电压无功自动控制系统（AVC）、电网运行方式智能联合优化分析系统、电网运行评估和辅助决策（OES）等产品和服务，致力于为坚强智能电网提供相关产品和技术支持、工程实施、系统集成及解决方案。\n\n     公司不仅具有高水平的电力技术，还配备了一支高素质的研发团队，核心成员以具备扎实电力业务水平的浙大博士、硕士毕业生与电力行业专家为主。致力于为各地电力局、企业等广大用户提供有竞争力的综合解决方案和服务。',
        },
        {
          part: '发展愿景',
          content: '未来的公司：沃瑞将成为一家具有科学发展理念、强烈社会责任感和强势竞争力的现代化企业。\n\n     未来的我们："沃瑞人"将成为一个有远见有抱负、不断进步和自我赶超的充满朝气的团队。\n\n     为了成为“电网优化的引导者”，沃瑞电力将上下同心，齐心协力为把公司打造成技术领先、运作有效、风险在控、管理科学的现代电网企业而努力奋斗。',
        },
        {
          part: '沃瑞荣誉',
          content: '',
        },
        {
          part: '团队文化',
          content: '经过十多年的发展沉淀，沃瑞电力已形成自己的独特文化。\n     对内：民主平等、务实求是、团结互助\n     对外：追求卓越、创新进取、合作共赢\n\n     求是：对待工作和知识，科学的追求和探索真理，正确地认知和解决问题。\n     创新：突破思维定势，推动思维创新、技术创新和管理创新。\n     团结：为了团队利益，齐心协力、团结协作、一往无前。\n     进取：为了共同目标，积极向上、努力追求，全力以赴。',
          content2: '每个在沃瑞平等开放的土地上辛勤耕耘的人。\n     “沃瑞人”的组成：\n     公司现有员工均为本科及以上学历，核心团队成员均有电力、计算机、营销、管理等专业知识和背景，团队既有多年从事电力技术研究开发的专家、海归学者，也有富有创新激情，可塑性极强的新一代大学生，部分技术骨干参与过多项省部级科技计划项目和企业产品开发，在电力系统研究开发方面具有丰富的经验。\n     “沃瑞人”的属性：\n     专业：积极倾听客户需求，精心构建产品质量，用心提供满意服务。\n     执行力：工作高效、团结协作、敢于担当、交付及时。\n     严谨：合理规划，严谨有序，脚踏实地、精益求精。\n     进取：积极进取、勇于开拓，知难而上，勇挑重担。\n     尊重：尊重知识，尊重人才，持续学习、超越自我。'
        },
      ],
      activePart: 0,
      honorList: [],
    }
  },
  created() {
    if (window.location.search) {
      this.activePart = window.location.search.split('=')[1]
    }
    this.getHonorData()
  },
  mounted() {

  },
  methods: {
    getHonorData() {
      this.$apis.abort_wr_list().then(res => {
        this.honorList = res.data.filter(item => item.showFlag == '是')
      })
    },
  },
}
</script>

<style lang='scss' scoped>
.about-wr-details {
  display: flex;
  flex-direction: column;
  min-height: 100%;

  .about-wr-details-main {
    flex: 1;

    .container {
      display: flex;

      .side {
        display: flex;
        flex-direction: column;
        text-align: left;
        margin-left: 350px;
        margin-top: 20px;

        .title {
          font-family: FZLanTingHei-H-GBK;
          font-weight: 600;
          font-size: 20px;
          color: #000000;
        }

        .about-item {
          margin-top: 10px;
          width: 100%;
          display: flex;
          align-items: center;
          cursor: pointer;

          .el-divider--horizontal {
            margin: 0;
            width: 40px;
            display: inline-block;
          }

          .part {
            margin-left: 10px;
            font-family: FZLanTingHei-R-GBK;
            font-weight: 400;
            font-size: 16px;
            color: #000000;
          }

          &:hover {
            .el-divider--horizontal {
              width: 60px;
              height: 2px;
              background-color: #000000;
            }

            .part {
              font-weight: 600;
            }
          }
        }

        .active {
          .el-divider--horizontal {
            width: 60px;
            height: 2px;
            background-color: #000000;
          }

          .part {
            font-weight: 600;
          }
        }
      }

      .content {
        width: calc(100% - 800px);
        height: 100%;
        white-space: pre-wrap;
        text-align: left;
        text-indent: 20px;
        margin: 10px 0 0 20px;
        line-height: 24px;

        .el-card {
          min-height: 300px;
        }

        .card3 {
          margin-top: 20px;
        }

        .honor-item {
          margin-bottom: 12px;
          display: flex;
          align-items: center;

          .honor-icon {
            width: 1.25rem;
            height: 1.0625rem;
          }

          .name {
            display: inline-block;
            text-indent: 4px;
          }
        }
      }
    }

  }

  .footer {
    margin-top: 20px;
  }
}
</style>